import React, { useCallback } from 'react';
import { Button, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';
import { MeSessionTimeout, useSessionContext } from 'modules/session';
import { ReactComponent as TI403Icon } from '../../common/routes/ErrorPage/icons/TimeIntelligence_403_Icon.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(6)
    },
    height: 'calc(100vh - 96px)',
    borderImageSlice: 1,
    borderImageSource: 'linear-gradient(to bottom, #2699FB, #00C2D7);',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  heading: {
    color: theme.palette.text.primary,
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('xl')]: {
      fontSize: '6vh'
    }
  },
  subHeading: {
    [theme.breakpoints.down('xl')]: {
      fontSize: '4vh'
    }
  },
  subText: {
    color: theme.palette.text.secondary,
    fontWeight: 600
  },
  icon: {
    margin: theme.spacing(3, 0),
    [theme.breakpoints.down('xl')]: {
      height: '30vh'
    }
  },
  button: {
    margin: theme.spacing(2),
    [theme.breakpoints.down('xl')]: {
      marginBottom: theme.spacing(1)
    }
  }
}));

export const NoAccess: React.FC = () => {
  const classes = useStyles();
  const { logout } = useSessionContext();
  const handleLogout = useCallback(async () => {
    await logout();
    window.location.assign('/');
  }, [logout]);

  return (
    <div className={classes.root} data-testid="no-access-container">
      <Typography variant="h2" className={classes.heading}>
        <FormattedMessage id="appTitle" />
      </Typography>
      <div>
        <TI403Icon className={classes.icon} />
      </div>
      <Typography variant="h4" className={classes.subHeading}>
        <FormattedMessage id="errorPage.noAccess.title" />
      </Typography>
      <Typography variant="body1" className={classes.subText}>
        <FormattedMessage id="errorPage.noAccess.subText" />
      </Typography>
      <Button
        data-testid="no-access-go-home-button"
        className={classes.button}
        color="primary"
        variant="contained"
        onClick={handleLogout}
      >
        <FormattedMessage id="errorPage.noAccess.buttonText" />
      </Button>
      <MeSessionTimeout />
    </div>
  );
};

export default NoAccess;
